module.exports = "<span class=\"pull-left login__footer-copyright\">&copy;\n     <span ng-bind=\"ctrl.currentYear\"></span>\n     Bubbles Online Services Ltd\n     <span><a href=\"{{::ctrl.privacyLink}}\" target=\"_blank\">{{::ctrl.privacyText}}</a></span>\n</span>\n<span class=\"pull-right login__footer-developed\"><span translate=\"developed_by\"></span>&nbsp;<a href=\"http://www.wave-access.com/\" target=\"_blank\">WaveAccess</a></span>\n";


//////////////////
// WEBPACK FOOTER
// ./src/app.common/modules/layout/footer/footer.component.html
// module id = 638
// module chunks = 6